import { render, staticRenderFns } from "./TestSales.vue?vue&type=template&id=dab44acc&scoped=true"
import script from "./TestSales.vue?vue&type=script&lang=js"
export * from "./TestSales.vue?vue&type=script&lang=js"
import style0 from "./TestSales.vue?vue&type=style&index=0&id=dab44acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab44acc",
  null
  
)

export default component.exports